export function isObject (val) {
  return val !== null && typeof val === 'object';
}

export function setItem (key, val) {
  if (isObject(val)) {
    localStorage.setItem(key, JSON.stringify(val));
  } else {
    localStorage.setItem(key, val);
  }
}

export function getItem (key) {
  var val = localStorage.getItem(key);

  try {
    return JSON.parse(val);
  } catch (e) {
    return val;
  }
}

export function removeItem (key) {
  localStorage.removeItem(key);
}

export function clear () {
  localStorage.clear();
}

export function getGameId() {
  let gameId = 0;
  try {
    gameId = Number(sessionStorage.getItem('game_id'));
  } catch (error) {
    
  }
  return gameId;
}

export default {
  isObject,
  setItem,
  getItem,
  removeItem,
  clear,
  getGameId
};
